<input [formControl]="formControl" type="checkbox" class="kgr-checkbox__control" />
<span class="kgr-checkbox__label"
  ><span [innerHTML]="label"></span>
  @if (required) {
    <span>*</span>
  }
</span>
